package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("DisablePublicPlanSharingRequest")
data class DisablePublicPlanSharingRequest(
    @JsName("globalEntryId")
    val globalEntryId: String
)